import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import './LoadingSpinner.scss';

const LoadingSpinner = ({ message = 'Loading...' }) => {
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, []);

  return ReactDOM.createPortal(
    <div className="loading-spinner-overlay">
      <div className="loading-spinner-container">
        <div className="spinner"></div>
        <p>{message}</p>
      </div>
    </div>,
    document.body
  );
};

export default LoadingSpinner;